import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { initialVesselReportsState } from '@navstation-portal/reporting/data-model/vessel-reports';
import { signalStoreFeature } from '@ngrx/signals';
import { removeEntity, upsertEntities } from '@ngrx/signals/entities';
import { on } from '@ngrx/signals/events';
import { vesselReportsEvents } from './vessel-reports-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withVesselReportsReducer<_>() {
  return signalStoreFeature(
    withTrackedReducer(
      on(vesselReportsEvents.fetchedVesselReports, ({ payload: reports }) => {
        return upsertEntities(reports);
      }),
      // A saved report's row may have changed (e.g. edits to an already
      // submitted report); upsert it so the list reflects the latest data
      // without a full refetch.
      on(vesselReportsEvents.reportSaved, ({ payload: { report } }) => {
        return upsertEntities([report]);
      }),
      // A submitted report becomes 'completed'; upsert its row so the list
      // reflects the new status without a full refetch.
      on(vesselReportsEvents.reportSubmitted, ({ payload: { report } }) => {
        return upsertEntities([report]);
      }),
      // A deleted report is removed from the list; never-saved reports have no
      // row (reportId undefined) so this is a no-op for them.
      on(vesselReportsEvents.reportDeleted, ({ payload: { reportId } }) => {
        return reportId ? removeEntity(reportId) : {};
      }),
      on(vesselReportsEvents.reset, () => initialVesselReportsState)
    )
  );
}
